var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarksuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#EBE4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5945 6.51829L14.6501 6.46471C14.6924 6.4371 14.7261 6.43077 14.7458 6.42992C14.768 6.42897 14.7819 6.43401 14.7889 6.43764C14.7868 6.45581 14.7704 6.53394 14.6482 6.65886L14.6349 6.67253L14.6226 6.68717L15.0057 7.00851C14.6226 6.68717 14.6226 6.6872 14.6225 6.68725L14.6223 6.68749L14.6215 6.68842L14.6184 6.69213L14.6061 6.70678L14.5582 6.76395L14.376 6.98127L13.7232 7.75986C13.1818 8.40588 12.4567 9.27135 11.7222 10.1491C10.2608 11.8955 8.74242 13.7139 8.58372 13.9211L8.57166 13.9369L8.56088 13.9535C8.47128 14.092 8.30568 14.1835 8.13066 14.1835C7.94083 14.1835 7.78476 14.0938 7.69473 13.9575L5.82682 10.9191C5.76396 10.808 5.78467 10.6668 5.90675 10.5723C6.05769 10.4705 6.24099 10.4906 6.3457 10.5812L7.91561 12.2585L8.26255 12.6292L8.62788 12.2766L14.5945 6.51829Z",
    fill: "#6F00FF",
    stroke: "#6F00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarksuccess);
export default __webpack_public_path__ + "static/media/marksuccess.029c1fef197613cccab574b24b351076.svg";
export { ForwardRef as ReactComponent };